export default "__VITE_ASSET__EoAv1_Wv__"